/**
* @license Apache-2.0
*
* Copyright (c) 2019 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MAIN //

/**
* Application configuration.
*
* @private
* @constant
* @type {Object}
*/
var config = {
	// Base URL path for API documentation:
	'mount': '/docs/api/',

	// Server endpoints:
	'routes': {
		// Application package data:
		'data': '/package/data.json',

		// List of package descriptions:
		'desc': '/package/desc.json',

		// Search index:
		'index': '/package/index.json',

		// Package list:
		'list': '/package/list.json',

		// Namespace list:
		'namespace': '/package/namespaces.json',

		// Hash specifying package order:
		'order': '/package/order.json',

		// Strided array indicating presence/absence of package resources:
		'resources': '/package/resources.json',

		// Package tree:
		'tree': '/package/tree.json',

		// Package tree array:
		'tree_array': '/package/tree-array.json'
	},

	// Supported documentation versions:
	'versions': [
		// NOTE: keep in reverse order (i.e., the latest version first)...
		'latest'
	],

	// Publicly hosted Git repository:
	'repository': 'https://github.com/stdlib-js/stdlib',

	// Publicly hosted blog:
	'blog': 'https://blog.stdlib.io',

	// Status and uptime:
	'status': 'https://status.stdlib.io',

	// Twitter:
	'twitter': 'https://twitter.com/stdlibjs',

	// Gitter:
	'gitter': 'https://gitter.im/stdlib-js/stdlib',
	'gitter_room': 'stdlib-js/stdlib',
	'gitter_script': '/js/common/gitter_sidecar.min.js',
	'gitter_load_delay': 3000, // in milliseconds

	// Sponsorship/funding URL:
	'funding': 'https://opencollective.com/stdlib',

	// Document title:
	'title': 'Documentation',

	// Document description:
	'description': 'Documentation for stdlib, a standard library for JavaScript and Node.js, with an emphasis on numerical and scientific computing.',

	// Documentation theme:
	'theme': 'light',

	// Documentation "mode":
	'mode': 'nested',

	// Example code syntax:
	'exampleSyntax': 'es5',

	// Previous/next package navigation:
	'prevNextNavigation': 'alphabetical'
};


// EXPORTS //

module.exports = config;
